import { ethers } from 'ethers';

export function shortAddress(addr) {
  if (!addr) return '';
  return addr.slice(0, 6) + '...' + addr.slice(-4);
}

export function formatUSDT(wei, opts = {}) {
  const { decimals = 2, symbol = '$' } = opts;
  if (wei === undefined || wei === null) return `${symbol}0.00`;
  try {
    const s = ethers.utils.formatUnits(wei, 18);
    const n = Number(s);
    if (!isFinite(n)) return `${symbol}0.00`;
    return `${symbol}${n.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
  } catch (_e) {
    return `${symbol}0.00`;
  }
}

export function toNumberSafe(wei) {
  try {
    return Number(ethers.utils.formatUnits(wei || 0, 18));
  } catch (_e) { return 0; }
}

export function bpToPct(bp) {
  const n = Number(bp || 0);
  return (n / 100).toFixed(2) + '%';
}

export function timeLeft(seconds) {
  if (seconds <= 0) return 'Ready';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  if (h > 0) return `${h}h ${m}m ${s}s`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

export function formatDate(ts) {
  if (!ts) return '—';
  const d = new Date(Number(ts) * 1000);
  return d.toLocaleString();
}
